import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// ——— Meta Tags Setup ———
document.title = 'ARSENA — Asset Resource Strategic Enterprise Network for Advanced-Technology';
const metaTags: Record<string, string>[] = [{
  name: 'description',
  content: 'ARSENA — Asset Resource Strategic Enterprise Network for Advanced-Technology. Mengelola aset teknologi strategis nasional mencakup server, jaringan, software, keamanan siber, dan infrastruktur digital untuk Badan Intelijen Negara Republik Indonesia.'
}, {
  name: 'keywords',
  content: 'ARSENA, manajemen aset, BIN, aset strategis, monitoring server, AI recommendations, audit, keamanan, teknologi strategis'
}, {
  name: 'author',
  content: 'Badan Intelijen Negara'
}, {
  name: 'robots',
  content: 'noindex, nofollow'
}, {
  name: 'theme-color',
  content: '#0B1945'
}, {
  name: 'color-scheme',
  content: 'light'
}, {
  name: 'application-name',
  content: 'ARSENA'
},
// Open Graph
{
  property: 'og:title',
  content: 'ARSENA — Asset Resource Strategic Enterprise Network for Advanced-Technology'
}, {
  property: 'og:description',
  content: 'Asset Resource Strategic Enterprise Network for Advanced-Technology — Badan Intelijen Negara Republik Indonesia.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:site_name',
  content: 'ARSENA'
}, {
  property: 'og:locale',
  content: 'id_ID'
}];
metaTags.forEach(attrs => {
  const meta = document.createElement('meta');
  Object.entries(attrs).forEach(([key, value]) => {
    meta.setAttribute(key, value);
  });
  document.head.appendChild(meta);
});
// Set lang attribute on html element
document.documentElement.lang = 'id';
render(<AppRouter data-id="element-3619" />, document.getElementById('root'));